module.exports = {
    templateUrl: 'case-law/components/case-law-links-to-news.html'
};